import { RouteRecordRaw } from 'vue-router';
import applicationsRoutes from './applicationsRoutes';
import availabilityRoutes from './availabilityRoutes';
import backupCareInviteRoutes from './backupCareInviteRoutes';
import bookingsRoutes from './bookingsRoutes';
import careCheckInRoutes from './careCheckInRoutes';
import jobSearchRoutes from './jobSearchRoutes';
import photoUploadRoutes from './photoUploadRoutes';
import profileEditRoutes from './profileEditRoutes';
import profileRoutes from './profileRoutes';
import providerApplicationsPageRoutes from './providerApplicationsPageRoutes';
import providersDashboardRoutes from './providersDashboard';
import reviewRoutes from './reviewRoutes';
import sitterOnboardingRoutes from './sitterOnboardingRoutes';

const providerRoutes = [
  ...applicationsRoutes,
  ...availabilityRoutes,
  ...backupCareInviteRoutes,
  ...bookingsRoutes,
  ...careCheckInRoutes,
  ...jobSearchRoutes,
  ...photoUploadRoutes,
  ...profileEditRoutes,
  ...profileRoutes,
  ...providerApplicationsPageRoutes,
  ...providersDashboardRoutes,
  ...reviewRoutes,
  ...sitterOnboardingRoutes,
] as RouteRecordRaw[];

export default providerRoutes;
